import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SpostaDocumentoRequest } from 'src/app/common/models/documento/sposta-documento-request';
import { CensimentoDocumenti } from 'src/app/common/models/sezioni/sezione-censimento-documenti/censimento-documenti';
import { TipiSezioneConfiguration } from '../../../../core/configuration/tipi-sezione-configuration';
import { IdDescrittoriDiSezione, NomiDescrittoriSezione } from '../../../configuration/nomi-descrittori-sezione';
import { DocumentoAllegato } from '../../../models/documento-allegato';
import { FileFolders } from "../../fascicolo/documentazione-allegata-view/documentazione-allegata.component";
import { DocumentoAddForm } from './documento-add-form.component';
import { UploadDocumentUtilityService } from 'src/app/common/form/documento/document-uploaded/upload-document-utility.service';

declare var closeModal: any;
declare var openModal: any;

@Component({
  selector: '[doc_add_modal]',
  templateUrl: 'documento-add-modal.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class DocumentoAddModal {
  @Output() onReturn = new EventEmitter<{ response: any; itemSelected: FileFolders }>();
  @Output() onReturnSpostaDoc = new EventEmitter();
  @Input()  entityList: Array<any> = [];
  @Input()  fascicolo: any;
  @Input() documentoSpostato: DocumentoAllegato;
  @ViewChild('docAddForm') documentAddForm: DocumentoAddForm;

  constructor(
    private uploadUtilityService: UploadDocumentUtilityService
  ) {}

  private documento: DocumentoAllegato;
  private sezione: any;
  private isMain: boolean;
  private esn: string;
  private formTitle: string;
  private fileUploadedName: string;
  private isSpostaDoc : boolean;
  itemSelected: FileFolders|null = null;

  initForm(
    url: string,
    sezione,
    fascicoloId: string = '',
    isMain: boolean,
    esn: string,
    formTitle: string,
    addDocToEntity: boolean,
    entity,
    isSpostaDoc?: boolean,
    requestSpostaDoc?: SpostaDocumentoRequest,
    fileList: DocumentoAllegato[] = [],
    itemSelected: FileFolders = null,
    separatorePathLogico: string = '',
    isFolder?: boolean,
    documento?: DocumentoAllegato,
    tipoPratica?: string,
    isCensimentoDocumenti: boolean = false,
    requestCensimentoDocumenti: CensimentoDocumenti = null
  ) {
    //this.uploadUtilityService.resetTipoProduttoreInitialized();
    this.entityList = this.getEntityList(sezione, esn);
    this.sezione = sezione;
    this.isSpostaDoc = isSpostaDoc ? isSpostaDoc : false;
    this.esn = esn;
    this.isMain = isMain;
    this.formTitle = formTitle;
    this.itemSelected = itemSelected;
    this.documentAddForm.buildForm(url, sezione, fascicoloId, isMain, esn, formTitle, addDocToEntity, entity, this.fascicolo, isSpostaDoc ? isSpostaDoc : false, requestSpostaDoc ? requestSpostaDoc : null, fileList, itemSelected, separatorePathLogico, isFolder, documento, tipoPratica, isCensimentoDocumenti, requestCensimentoDocumenti ? requestCensimentoDocumenti : null);
      if (sezione.tipoSezione && sezione.tipoSezione.label === "TITOLI ESECUTIVI") {
          openModal('titoloDocAddModal');
      } else {
          openModal('docAddModal');
      }
  }

  initFormAlternative(
    url: string,
    sezione,
    fascicoloId: string = '',
    isMain: boolean,
    esn: string,
    formTitle: string,
    addDocToEntity: boolean,
    entity,
    isSpostaDoc?: boolean,
    requestSpostaDoc?: SpostaDocumentoRequest,
    fileList: DocumentoAllegato[] = [],
    itemSelected: FileFolders = null,
    separatorePathLogico: string = '',
    isFolder?: boolean,
    documento?: DocumentoAllegato,
    tipoPratica?: string,
    isCensimentoDocumenti: boolean = false,
    requestCensimentoDocumenti: CensimentoDocumenti = null
  ) {
    //this.uploadUtilityService.resetTipoProduttoreInitialized();
    this.entityList = this.getEntityList(sezione, esn);
    this.sezione = sezione;
    this.isSpostaDoc = isSpostaDoc ? isSpostaDoc : false;
    this.esn = esn;
    this.isMain = isMain;
    this.formTitle = formTitle;
    this.documentAddForm.buildForm(url, sezione, fascicoloId, isMain, esn, formTitle, addDocToEntity, entity, this.fascicolo, isSpostaDoc ? isSpostaDoc : false, requestSpostaDoc ? requestSpostaDoc : null, fileList, itemSelected, separatorePathLogico, isFolder, documento, tipoPratica, isCensimentoDocumenti, requestCensimentoDocumenti ? requestCensimentoDocumenti : null);
    this.getAlternativeIdModal(sezione);
  }

  private getAlternativeIdModal(sezione: any) {
    switch (sezione.esn) {
      case NomiDescrittoriSezione.SEZIONE_CONTROPARTI_FASCICOLO:
        openModal('docAddModalParti');
        break;
      case NomiDescrittoriSezione.SEZIONE_ALTRE_PARTI_FASCICOLO:
        openModal('docAddModalAltreParti');
        break;
      case NomiDescrittoriSezione.SEZIONE_SCADENZARIO_FASCICOLO:
        openModal('docAddModalScadenze');
        break;
      case NomiDescrittoriSezione.SEZIONE_ATTI_FASCICOLO:
        openModal('docAddModalAtti');
        break;
      default:
        break;
    }
  }

  getEntityList(sezione, esn){
    // debugger
    let arrayList = [];
    for (let idDescrittore of IdDescrittoriDiSezione.TutteLeSezioni) {
      if (idDescrittore.esn === esn) {
        arrayList = sezione[idDescrittore.nomeCampoEntityList];
      }
    }
    return arrayList;
  }

  createForm() {
    //this.uploadUtilityService.resetTipoProduttoreInitialized();
    this.entityList = [];
    this.documentAddForm.setTextEmpty();
    this.documentAddForm.createForm();
  }

  onDocumentoSpostato(event){
    closeModal('docAddModal');
    this.onReturnSpostaDoc.emit(event);
  }

  manageModal(response: {response: any}) {
    if (response) {
      //this.uploadUtilityService.resetTipoProduttoreInitialized();
      const payload = {
        response: response.response,
        itemSelected: this.itemSelected // questo contiene il path corrente
      };
      if (this.sezione.tipoSezione && this.sezione.tipoSezione.label === "TITOLI ESECUTIVI") {
        closeModal('titoloDocAddModal');
      } else {
        closeModal('docAddModal');
      }

      this.onReturn.emit(payload);

    }
  }
}
